export const EVENT_NAMES = {
  // Quick actions card events
  TAKE_ASSESSMENT_CLICKED: "take_assessment_clicked",

  LOGIN_BUTTON_CLICKED: "login_button_clicked",

  // program & onboarding screens
  JOIN_PROGRAM_CLICKED: "join_program_clicked",
  AGREE_TO_TERMS_AND_CONDITIONS_CLICKED:
    "agree_to_terms_and_conditions_clicked",
  SEND_OTP_CLICKED: "send_otp_clicked",
  SEND_OTP_SUCCESS: "send_otp_success",
  SEND_OTP_ERROR: "send_otp_error",
  VERIFY_OTP_CLICKED: "verify_otp_clicked",
  VERIFY_OTP_SUCCESS: "verify_otp_success",
  VERIFY_OTP_ERROR: "verify_otp_error",
  RESEND_OTP_CLICKED: "resend_otp_clicked",
  RESEND_OTP_SUCCESS: "resend_otp_success",
  RESEND_OTP_ERROR: "resend_otp_error",
  FOUND_NEW_USER: "found_new_user",
  FOUND_EXISTING_USER: "found_existing_user",
  USER_TYPE_SELECTED: "user_type_selected",
  NAME_CAPTURED: "name_captured",
  GENDER_SELECTED: "gender_selected",
  DOB_CAPTURED: "dob_captured",
  DOCTOR_DETAILS_CAPTURED: "doctor_details_captured",
  UPLOAD_DOCUMENTS_CONTINUE_CLICKED: "upload_documents_continue_clicked",
  SELECT_DOCTOR_STATE_INPUT_CLICKED: "select_doctor_state_input_clicked",
  SELECT_DOCTOR_CITY_INPUT_CLICKED: "select_doctor_city_input_clicked",
  SELECT_DOCTOR_HOSPITAL_INPUT_CLICKED: "select_doctor_hospital_input_clicked",
  SELECT_DOCTOR_INPUT_CLICKED: "select_doctor_input_clicked",
  SELECT_DOCTOR_STATE_BOTTOM_SHEET_OPENED:
    "select_doctor_state_bottom_sheet_opened",
  SELECT_DOCTOR_CITY_BOTTOM_SHEET_OPENED:
    "select_doctor_city_bottom_sheet_opened",
  SELECT_DOCTOR_HOSPITAL_BOTTOM_SHEET_OPENED:
    "select_doctor_hospital_bottom_sheet_opened",
  SELECT_DOCTOR_STATE_BOTTOM_SHEET_CLOSED:
    "select_doctor_state_bottom_sheet_closed",
  SELECT_DOCTOR_CITY_BOTTOM_SHEET_CLOSED:
    "select_doctor_city_bottom_sheet_closed",
  SELECT_DOCTOR_HOSPITAL_BOTTOM_SHEET_CLOSED:
    "select_doctor_hospital_bottom_sheet_closed",
  SELECT_DOCTOR_BOTTOM_SHEET_OPENED: "select_doctor_bottom_sheet_opened",
  SELECT_DOCTOR_BOTTOM_SHEET_CLOSED: "select_doctor_bottom_sheet_closed",
  DOCTOR_STATE_SELECTED: "doctor_state_selected",
  DOCTOR_CITY_SELECTED: "doctor_city_selected",
  DOCTOR_HOSPITAL_SELECTED: "doctor_hospital_selected",
  DOCTOR_SELECTED: "doctor_selected",
  ONBOARDING_SUCCESS: "onboarding_success",
  ONBOARDING_ERROR: "onboarding_error",

  // app links events
  DOWNLOAD_FOR_ANDROID_CLICKED: "download_for_android_clicked",
  DOWNLOAD_FOR_IOS_CLICKED: "download_for_ios_clicked",
  DOWNLOAD_FOR_ANDROID_REDIRECTED: "download_for_android_redirected",
  DOWNLOAD_FOR_IOS_REDIRECTED: "download_for_ios_redirected",

  // program documents
  RECORD_UPLOAD_CLICKED: "record_upload_clicked",
  RECORD_UPLOAD_SUCCESS: "record_upload_success",
  RECORD_UPLOAD_ERROR: "record_upload_error",

  // Treatment journey events
  TREATMENT_JOURNEY_CARD_RIGHT_ICON_CLICKED:
    "treatment_journey_card_right_icon_clicked",
  VIEW_CYCLE_DETAILS_CLICKED: "view_cycle_details_clicked",
  ON_PRESS_YES_CLICKED: "on_press_yes_clicked",
  ON_PRESS_YES_SUCCESS: "on_press_yes_success",
  ON_PRESS_YES_ERROR: "on_press_yes_error",
  ON_PRESS_NO_CLICKED: "on_press_no_clicked",
  CLAIM_FREE_DRUG_CLICKED: "claim_free_drug_clicked",
  CLAIM_FREE_DRUG_SUCCESS: "claim_free_drug_success",
  CLAIM_FREE_DRUG_ERROR: "claim_free_drug_error",

  // Services card events
  BOOK_APPOINTMENT_CLICKED: "book_appointment_clicked",
  CHAT_CLICKED: "chat_clicked",
  BOOK_LAB_TESTS_CLICKED: "book_lab_tests_clicked",
  HEALTH_STORE_CLICKED: "health_store_clicked",
  CALL_TELECOUNSELOR_CLICKED: "call_telecounselor_clicked",
  CLINICAL_APPOINTMENTS_CLICKED: "clinical_appointments_clicked",
  // Todays reminders events
  SET_GOAL_CLICKED: "set_goal_clicked",
  LOG_NOW_CLICKED: "log_now_clicked",

  // Todays progress events
  TODAYS_PROGRESS_ITEM_CLICKED: "todays_progress_item_clicked",

  // Educational content card events
  EDUCATIONAL_CONTENT_CARD_RIGHT_ICON_CLICKED:
    "educational_content_card_right_icon_clicked",
  EDUCATIONAL_CONTENT_LIST_ITEM_CLICKED:
    "educational_content_list_item_clicked",

  // Wallet card events
  WALLET_CARD_USE_COINS_CLICKED: "wallet_card_use_coins_clicked",

  // Book consultation events
  BOOK_COACH_CLICKED: "book_coach_clicked",
  BOOK_COACH_PAYMENT_CLICKED: "book_coach_payment_clicked",
  BOOK_COACH_PAYMENT_SUCCESS: "book_coach_payment_success",
  BOOK_COACH_PAYMENT_ERROR: "book_coach_payment_error",
  CONSULTATION_PLAN_SUCCESS: "consultation_plan_success",
  CONSULTATION_PLAN_ERROR: "consultation_plan_error",
  APPOINTMENT_BOOKING_CLICKED: "appointment_booking_clicked",
  APPOINTMENT_BOOKING_SUCCESS: "appointment_booking_success",
  APPOINTMENT_BOOKING_ERROR: "appointment_booking_error",
  CONSULTATION_CANCEL_CLICKED: "consultation_cancel_clicked",
  CONSULTATION_CONFRIM_CANCEL_CLICKED: "consultation_confirm_cancel_clicked",
  CONSULTATION_CONFRIM_CANCEL_SUCCESS: "consultation_confirm_cancel_success",
  CONSULTATION_CONFRIM_CANCEL_ERROR: "consultation_confirm_cancel_error",

  // common for both consultation and lab test
  AVAILABLE_SLOTS_LOAD_SUCCESS: "available_slots_load_success",
  AVAILABLE_SLOTS_LOAD_ERROR: "available_slots_load_error",
  SLOT_SELECTION_CLICKED: "slot_selection_clicked",

  // Book lab test events
  LAB_TEST_ADD_TO_CART_CLICKED: "lab_test_add_to_cart_clicked",
  LAB_TEST_ADD_TO_CART_SUCCESS: "lab_test_add_to_cart_success",
  LAB_TEST_ADD_TO_CART_ERROR: "lab_test_add_to_cart_error",
  LAB_TEST_REMOVE_CART_CLICKED: "lab_test_remove_cart_clicked",
  LAB_TEST_REMOVE_CART_SUCCESS: "lab_test_remove_cart_success",
  LAB_TEST_REMOVE_CART_ERROR: "lab_test_remove_cart_error",
  LAB_TEST_PAYMENT_CLICKED: "lab_test_payment_clicked",
  LAB_TEST_PAYMENT_SUCCESS: "lab_test_payment_success",
  LAB_TEST_PAYMENT_ERROR: "lab_test_payment_error",
  LAB_TEST_APPOINTMENT_BOOKING_CLICKED: "lab_test_appointment_booking_clicked",
  LAB_TEST_APPOINTMENT_BOOKING_SUCCESS: "lab_test_appointment_booking_success",
  LAB_TEST_APPOINTMENT_BOOKING_ERROR: "lab_test_appointment_booking_error",

  // Insights events/ for reminders and goals
  SET_REMINDER_NOW_CLICKED: "set_reminder_now_clicked",
  SET_GOALS_CLICKED: "set_goals_clicked",
};

export const SCREEN_NAMES = {
  // auth screens
  LOGIN_SCREEN: "login_screen",

  // program & onboarding screens
  PROGRAM_LIST_SCREEN: "program_list_screen",
  PROGRAM_DETAILS_SCREEN: "program_details_screen",
  ONBOARDING_SCREEN: "onboarding_screen",
  MOBILE_NUMBER_CAPTURE_SCREEN: "mobile_number_capture_screen",
  OTP_CAPTURE_SCREEN: "otp_capture_screen",
  USER_TYPE_SELECTION_SCREEN: "user_type_selection_screen",
  NAME_CAPTURE_SCREEN: "name_capture_screen",
  GENDER_SELECTION_SCREEN: "gender_selection_screen",
  DOB_CAPTURE_SCREEN: "dob_capture_screen",
  DOCTOR_DETAILS_CAPTURE_SCREEN: "doctor_details_capture_screen",
  UPLOAD_DOCUMENTS_SCREEN: "upload_documents_screen",
  EXISTING_USER_SCREEN: "existing_user_screen",
  ONBOARDING_SUCCESS_SCREEN: "onboarding_success_screen",

  // app links screens
  APP_DOWNLOAD_SCREEN: "app_download_screen",

  // landing screens
  HOME_SCREEN: "home_screen",
  PROGRAM_SCREEN: "program_screen",
  HEALTH_ASSISTANT_SCREEN: "health_assistant_screen",
  INSIGHTS_SCREEN: "insights_screen",
  RECORDS_SCREEN: "records_screen",

  // profile screens
  PROFILE_SCREEN: "profile_screen",
  EDIT_PROFILE_SCREEN: "edit_profile_screen",
  ADD_CAREGIVER_SCREEN: "add_caregiver_screen",

  // Treatment journey screens
  TREATMENT_JOURNEY_SCREEN: "treatment_journey_screen",

  // Cycle details screens
  CYCLE_DETAILS_SCREEN: "cycle_details_screen",

  // Claim details screens
  CLAIM_DETAILS_SCREEN: "claim_details_screen",

  // Book consultation screens
  BOOK_CONSULTATION_SCREEN: "book_consultation_screen",
  CONSULTATION_PAYMENT_CHECKOUT_SCREEN: "consultation_payment_checkout_screen",

  // common for both consultation and lab test
  SLOT_SELECTION_SCREEN: "slot_selection_screen",

  // Book lab test screens
  BOOK_LAB_TEST_SCREEN: "book_lab_test_screen",
  LAB_TEST_PAYMENT_CHECKOUT_SCREEN: "lab_test_payment_checkout_screen",

  // Todays progress screens
  LOG_DETAILS_SCREEN: "log_details_screen",

  // Learn content list screens
  LEARN_CONTENT_LIST_SCREEN: "learn_content_list_screen",
  LEARN_CONTENT_DETAILS_SCREEN: "learn_content_details_screen",
};
